import script from "./ControllLocation.vue?vue&type=script&lang=js"
export * from "./ControllLocation.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__